import { useEffect, useState } from "react";

/** O valor só muda depois de `delayMs` sem novas mudanças — para buscar enquanto a pessoa digita. */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
